module.exports = __webpack_public_path__ + "static/img/ninja-can-13.85cc72af.png";